import axios from 'axios';
import { ErrorType, UserType } from './ActionType';
import AppConfig from '../config';

const API_URL = AppConfig.API_URL;

export const getTranslations = (lang) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/translations/${lang}`)
      .then((res) => {
        dispatch({ type: UserType.GET_TRANSLATION, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const fetchDoctors = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors`)
      .then((res) => {
        callback(res.data.result)
        // dispatch({ type: UserType.GET_ALL_DOCTORS, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getUser = (id) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/${id}`)
      .then((res) => {
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDoctor = (token) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusiness = (latitude, longitude) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/business/${latitude}/${latitude}`)
      .then((res) => {
        dispatch({ type: UserType.GET_BUSINESS, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusinessById = (id) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/business/${id}`)
      .then((res) => {
        dispatch({ type: UserType.GET_BUSINESS_INFO, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const checkBusinessById = (id, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/business/checkBusiness/byBusinessId/user/${id}`)
      .then((res) => {
        callback && callback(res.data);
      })
      .catch((err) => {
        callback && callback();
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const addBusinessForuser = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/userMapping`, data)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateBusinessForBusiness = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/userMapping/updateUsermapping/${id}`, data)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUserMappingById = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/userMapping/${id}`, data)
      .then((res) => {
        callback(res.data.result, true);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusinessForuser = (id, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/userMapping/${id}`)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusinessForBusiness = (id, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/userMapping/byBusiness/${id}`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusinessForBusinessActive = (id, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/userMapping/byBusinessActive/${id}`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getUsersBusiness = (business, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/userMapping/byBusinessActive/${business}/${user}`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getToken = (token, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/businessTokens/${token}`)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const checkBusinessId = (business, callback, column) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/checkbusiness/${business}`)
      .then((res) => {
        callback(res.data, column)
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDoctorByEmail = (email, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/getByEmail/${email}`)
      .then((res) => {
        callback(res.data, callback)
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDoctorByBusiness = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/getDoctorByBusiness/${business}`)
      .then((res) => {
        callback && callback(res.data.result)
        dispatch({ type: UserType.GET_ALL_DOCTORS, payload: res.data.result });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDoctorByBusinessManagement = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/getByBusinessForManagement/${business}`)
      .then((res) => {
        callback && callback(res.data.result)
        dispatch({ type: UserType.GET_ALL_DOCTORS, payload: res.data.result });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const checkDuplicateEmail = (email, callback, column, business) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/checkemail/${business}/${email}`)
      .then((res) => {
        callback(res.data, column)
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const login = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/doctors/login`, data)
      .then((res) => {
        callback(res.data);
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createUser = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/doctors/byAdmin`, data)
      .then((res) => {
        callback(res.data.result, 'User Created')
        // dispatch({ type: UserType.CREATE_USERS, payload: res.data });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const removeUser = (business, data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/doctors/removeUser/byAdmin/${business}`, data)
      .then((res) => {
        callback(res.data.result, 'User Removed')
        // dispatch({ type: UserType.CREATE_USERS, payload: res.data });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createBusiness = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/business`, data)
      .then((res) => {
        callback(res.data)
        // dispatch({ type: UserType.CREATE_USERS, payload: res.data });
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const deleteUser = (id, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/Login/users/${id}`)
      .then((res) => {
        dispatch({ type: UserType.DELETE_USERS, payload: res.data });
        callback(res);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUser = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/doctors/${id}`, data)
      .then((res) => {
        callback(res.data.result)
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUserByAdmin = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/doctors/updateUser/doctor/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'User Updated');
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const updatePassword = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/doctors/updatepassword/${id}`, data)
      .then((res) => {
        callback(res.data)
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const forgotPassword = (business, email, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/doctors/forgotpassword/${business}/${email}`)
      .then((res) => {
        callback(res.data);
        // dispatch({ type: UserType.UPDATE_USER, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateDoctorById = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/doctors/updateDoctor/${id}`, data)
      .then((res) => {
        callback(res.data)
        dispatch({ type: UserType.GET_USER, payload: res.data.result });
        dispatch(getTranslations(res.data.result.preferredLanguage))
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const resetPasswordDoctor = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/doctors/resetPassword/${id}`, data)
      .then((res) => {
        callback(res.data)
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateBusinessById = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/business/${id}`, data)
      .then((res) => {
        callback(res.data)
        dispatch({ type: UserType.GET_BUSINESS_INFO, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateBusinessOrderEmail = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/business/updateOrderEmail/${id}`, data)
      .then((res) => {
        callback(res.data)
        dispatch({ type: UserType.GET_BUSINESS_INFO, payload: res.data.result });
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateToken = (id) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/businessTokens/${id}`, {})
      .then((res) => {
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateTokenForgotPassword = (id) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/businessTokens/password/${id}`, {})
      .then((res) => {
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getCountries = (callback, type) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/countries/countries`)
      .then((res) => {
        if (res) {
          callback(res.data.result, type)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getStates = (country, callback, type) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/states/states/${country}`)
      .then((res) => {
        if (res) {
          callback(res.data.result, type)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getCities = (state, callback, type) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/cities/cities/${state}`)
      .then((res) => {
        if (res) {
          callback(res.data.result, type)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getRefData = (business, doctor, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/drugMaster/${business}/${doctor}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const uploadExcelRefData = (business, data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/drugMaster/${business}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const uploadCustomRefDataForBusiness = (business, type, data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/drugMaster/uploadCustomDataForBusiness/${business}/${type}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const uploadCustomRefData = (business, data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/drugMaster/uploadCustomData/${business}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getDrugMaster = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/drugMaster/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getBusinessSetting = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/businessSetting/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateBusinessSetting = (businessData, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/businessSetting`, businessData)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'true')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const addDrugData = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/drugMaster/addDrugData/master`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDrugMasterAudit = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/drugMasterAudit/${business}`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getSubscriptionByBusiness = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/subscription/${business}`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getSubscription = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/subscription`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getMasterSubscription = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/subscriptionMaster`)
      .then((res) => {
        callback(res.data.result);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createMasterSubscription = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/subscriptionMaster`, data)
      .then((res) => {
        callback(res.data.result, 'Subscription Added');
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateMasterSubscription = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/subscriptionMaster/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Subscription updated');
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateSubscription = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/subscription/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'true');
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const MakePament = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/subscription/payment`, data)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        // dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAllBusinessSetting = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/businessSetting`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateBusinessSettingAdmin = (businessData, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/businessSetting/updateSetting`, businessData)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'true')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAuditHistoryData = (url, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/${url}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateUserConsultation = (id, data, callback) => {
  return function (dispatch) {
    return axios
      .put(`${API_URL}/userMapping/users/consultation/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Consultation Opened')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getConsultation = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/consultationDetails/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getConsultationUser = (business, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/consultationDetails/${business}/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getConsultationByRequested = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/consultationDetails/requestedConsultation/requested/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getVisits = (business, consultationId, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/visitingDetails/${business}/${consultationId}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createVisits = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/visitingDetails`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Visit Added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateVisits = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/visitingDetails/${id}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Visit Updated')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getConsultationDrugDetails = (visitingId, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/consultationDrugDetails/${visitingId}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAllConsultationDrugDetails = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/consultationDrugDetails`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createConsultationDrugDetails = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/consultationDrugDetails`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Consultation Drug Details Added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateConsultationDrugDetails = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/consultationDrugDetails/${id}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Consultation Drug Details Updated')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getClosedOrdersForUser = (business, user, callback) => {
  return function (dispatch) {
    return axios
      .get(`${API_URL}/drugOrders/userOrders/closed/${business}/${user}`)
      .then((res) => {
        callback(res.data.result)
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
}

export const getordersByConsultation = (business, consultationId, callback) => {
  return function (dispatch) {
    return axios
      .get(`${API_URL}/drugOrders/userOrders/consultation/${business}/${consultationId}`)
      .then((res) => {
        callback(res.data.result)
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
}

export const createBillSummary = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/billSummary`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Bill added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDrugMasterData = (business) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/drugMaster/${business}`)
      .then((res) => {
        if (res) {
          dispatch({ type: UserType.GET_MASTER_DRUG, payload: res.data.result });
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createDataRequest = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/patientDataRequest`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Request Sent')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getDataRequestActiveInActive = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/activeInActive/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getInActiveDataRequest = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/inActive/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getActiveDataRequest = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getRemovedDataRequest = (business, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/patientDataRequest/removed/${business}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAppointment = (business, doctor, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/appointments/${business}/${doctor}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getAppointmentUser = (business, doctor, user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/appointments/${business}/${doctor}/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const createAppointment = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/appointments`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Appointment Added')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateAppointment = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/appointments/${id}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Appointment Updated')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const sendContactUs = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/contactUs`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Message Sent')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getContactUs = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/contactUs`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateContactUs = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/contactUs/${id}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result, 'contact Us Updated')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const sendEmailToPatients = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/emailToPatient`, data)
      .then((res) => {
        if (res) {
          callback(res.data, 'Email Sent')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateAdmin = (id, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/admins/${id}`, {})
      .then((res) => {
        if (res) {
          callback(res.data.result, 'Updated')
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


// WEBPACK FOOTER //
// ./actions/BusinessUserActions.js